import { useSyncExternalStore } from "react";
import {
  getCloudHumansReady,
  subscribeCloudHumansReady,
} from "@/utils/cloudHumans";

export const useCloudHumansReady = () =>
  useSyncExternalStore(
    subscribeCloudHumansReady,
    getCloudHumansReady,
    getCloudHumansReady,
  );
